<template>
  <div class="nav-main">
    <div class="main-nav">
      <div
        class="row"
        style="justify-content: space-between; align-items: center;"
      >
        <div
          class="nav-title"
          style="
            margin-right: 9px;
            justify-content: center;
            align-items: center;
          "
        >
          <img
            src="../../assets/img/logo.png"
            style="height: 40px;margin-right:9px;"
          />
          <div style="padding-top:2px;">
            <h2 style="font-size: 18px;color:#000; font-weight: 400;    padding-bottom: 5px;">
              上海新龙塑料制造有限公司
            </h2>
            <p
              style="font-size: 12px; font-weight: 400; color:#000;letter-spacing: .5px;"
            >
              Shanghai Xinlong Plastic Manufacturing Co.,Ltd
            </p>
          </div>
        </div>
        <div>
          <Input
            v-model="productName"
            :placeholder="$t('lang.enterText')"
            size="large"
            style="width: 800px;background:#FAFAFA;"
            @keyup.enter.native="searchEnterFun"
          >
            <Icon type="ios-search" slot="prefix" />
          </Input>
        </div>
      </div>
      <div class="row" style="justify-content: space-between;">
        <div>
          <Menu
            ref="menu"
            mode="horizontal"
            @on-select="route"
            activeName="1"
            v-if="active == 1"
          >
            <Menu-item name="1">
              <span>{{ $t("lang.home") }}</span>
            </Menu-item>
            <Menu-item name="2">
              {{ $t("lang.newsinfo") }}
            </Menu-item>
            <Menu-item name="3">
              {{ $t("lang.cmpintr") }}
            </Menu-item>
            <Menu-item name="4">
              {{ $t("lang.newproduct") }}
            </Menu-item>
            <Menu-item name="5">
              {{ $t("lang.downloadcenter") }}
            </Menu-item> </Menu
          ><Menu
            ref="menu"
            mode="horizontal"
            @on-select="route"
            activeName="2"
            v-if="active == 2"
          >
            <Menu-item name="1">
              {{ $t("lang.home") }}
            </Menu-item>
            <Menu-item name="2">
              <span>{{ $t("lang.newsinfo") }}</span>
            </Menu-item>
            <Menu-item name="3">
              {{ $t("lang.cmpintr") }}
            </Menu-item>
            <Menu-item name="4">
              {{ $t("lang.newproduct") }}
            </Menu-item>
            <Menu-item name="5">
              {{ $t("lang.downloadcenter") }}
            </Menu-item>
          </Menu>
          <Menu
            ref="menu"
            mode="horizontal"
            @on-select="route"
            activeName="3"
            v-if="active == 3"
          >
            <Menu-item name="1">
              {{ $t("lang.home") }}
            </Menu-item>
            <Menu-item name="2">
              {{ $t("lang.newsinfo") }}
            </Menu-item>
            <Menu-item name="3">
              <span>{{ $t("lang.cmpintr") }}</span>
            </Menu-item>
            <Menu-item name="4">
              {{ $t("lang.newproduct") }}
            </Menu-item>
            <Menu-item name="5">
              {{ $t("lang.downloadcenter") }}
            </Menu-item>
          </Menu>
          <Menu
            ref="menu"
            mode="horizontal"
            @on-select="route"
            activeName="4"
            v-if="active == 4"
          >
            <Menu-item name="1">
              {{ $t("lang.home") }}
            </Menu-item>
            <Menu-item name="2">
              {{ $t("lang.newsinfo") }}
            </Menu-item>
            <Menu-item name="3">
              {{ $t("lang.cmpintr") }}
            </Menu-item>
            <Menu-item name="4">
              <span>{{ $t("lang.newproduct") }}</span>
            </Menu-item>
            <Menu-item name="5">
              {{ $t("lang.downloadcenter") }}
            </Menu-item>
          </Menu>
          <Menu
            ref="menu"
            mode="horizontal"
            @on-select="route"
            activeName="5"
            v-if="active == 5"
          >
            <Menu-item name="1">
              {{ $t("lang.home") }}
            </Menu-item>
            <Menu-item name="2">
              {{ $t("lang.newsinfo") }}
            </Menu-item>
            <Menu-item name="3">
              {{ $t("lang.cmpintr") }}
            </Menu-item>
            <Menu-item name="4">
              {{ $t("lang.newproduct") }}
            </Menu-item>
            <Menu-item name="5">
              <span>{{ $t("lang.downloadcenter") }}</span>
            </Menu-item>
          </Menu>
          <Menu
            ref="menu"
            mode="horizontal"
            @on-select="route"
            v-if="active == 6"
          >
            <Menu-item name="1">
              {{ $t("lang.home") }}
            </Menu-item>
            <Menu-item name="2">
              {{ $t("lang.newsinfo") }}
            </Menu-item>
            <Menu-item name="3">
              {{ $t("lang.cmpintr") }}
            </Menu-item>
            <Menu-item name="4">
              {{ $t("lang.newproduct") }}
            </Menu-item>
            <Menu-item name="5">
              {{ $t("lang.downloadcenter") }}
            </Menu-item>
          </Menu>
        </div>
        <div
          style="
            display: flex;
            justify-content: flex-end;
            align-items: center;
            padding-right: 25px;
          "
        >
          <div
            style="cursor: pointer; font-size: 16px; padding-right: 5px;"
            :style="{ color: langCn }"
            @click="toCN"
          >
            {{ $t("lang.zw") }}
          </div>
          |
          <div
            style="cursor: pointer; font-size: 16px; padding-left: 5px;"
            :style="{ color: langEn }"
            @click="toEN"
          >
            {{ $t("lang.yw") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",

  data() {
    return {
      modal5: false,
      active: 1,
      langCn: "",
      langEn: "",
      productName: "",
    };
  },
  created() {
    this.$nextTick(() => {
      this.$refs.menu.updateOpened();
      this.$refs.menu.updateActiveName();
    });
    if (this.$route.meta.name) {
      this.active = this.$route.meta.name;
    } else {
      this.active = 6;
    }

    if (localStorage.getItem("lang") == "cn") {
      this.langCn = "red";
      this.langEn = "#333";
    } else {
      this.langEn = "red";
      this.langCn = "#333";
    }
  },
  methods: {
    route(name) {
      if (name == 3) {
        this.$router.push("aboutus");
      } else if (name == 1) {
        this.$router.push("index");
      } else if (name == 2) {
        this.$router.push("news");
      } else if (name == 4) {
        this.$router.push("newproduct");
      } else if (name == 5) {
        this.$router.push("download");
      }
    },
    toCN() {
      this.$i18n.locale = "zh-CN";
      localStorage.setItem("lang", "cn");
      if(this.$route.path=='/index'){
      	location.reload();
      }else{
      	this.$router.push("index");
      }

    },
    toEN() {
      this.$i18n.locale = "en-US";
      localStorage.setItem("lang", "en");
      if(this.$route.path=='/index'){
      	location.reload();
      }else{
      	this.$router.push("index");
      }
    },
    searchEnterFun: function(e) {
      // 使用 which 和 keyCode 属性来解决兼容问题
      let _this = this;
      var keyCode = window.event ? e.keyCode : e.which;
      var val = e.target.value;
      if (keyCode == 13 && val) {
        _this.$router.push({
          path: "/filter",
          query: { productName: _this.productName },
        });
      }
    },
  },
  mounted() {},
};
</script>

<style>
.nav-main {
  display: flex;
  top: 0;
  left: 0;
  min-width: 1200px;
  width: 100%;
  height: 135px;
  position: fixed;
  z-index: 500;
  background: #fff;
  box-shadow: 0px 2px 5px 0px rgba(116, 116, 116, 0.5);
}
.nav-main .ivu-menu-horizontal.ivu-menu-light:after {
  background: none;
}
.nav-main .ivu-menu-horizontal .ivu-menu-item,
.nav-main .ivu-menu-horizontal .ivu-menu-submenu {
  min-width: 205px;
  text-align: left;
  border-bottom: none;
  font-size: 16px;
  font-weight: 600;
}
.nav-main .ivu-menu-light {
  background: none;
}
.nav-main .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover,
.nav-main .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active {
  color: #515a6e;
  border-bottom: none;
}
.nav-main .ivu-menu-item span {
  position: relative;
  font-size: 18px;
  color: #000000;
  font-weight: 600;
}
.nav-main .ivu-menu-item span::after {
  position: absolute;
  display: block;
  content: " ";
  width: 30px;
  height: 2px;
  background-color: red;
  left: 50%;
  bottom: 0;
  top:25px;
  transform: translate3d(-50%, 0, 0);
}
.nav-main {
  width: 100%;
  min-width: 1200px;
  margin: auto;
  padding: 17px 0 9px;
}
.main-nav {
  width: 1200px;
  margin: auto;
}
.nav-title {
  display: flex;
}
</style>
